// src/App.jsx — Root app component with ErrorBoundary
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './store/AuthContext';
import AppRoutes from './routes/AppRoutes';
import ErrorBoundary from './components/ErrorBoundary';
import './styles/globals.css';

const App = () => (
  <BrowserRouter>
    <ErrorBoundary>
      <AuthProvider>
        <AppRoutes />
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 3500,
            style: {
              fontFamily: 'Sora, sans-serif',
              fontSize: '13.5px',
              fontWeight: 500,
              borderRadius: '10px',
              boxShadow: '0 8px 24px rgba(0,0,0,.15)',
            },
            success: { iconTheme: { primary: '#1D9E75', secondary: '#fff' } },
            error:   { iconTheme: { primary: '#EF4444', secondary: '#fff' } },
          }}
        />
      </AuthProvider>
    </ErrorBoundary>
  </BrowserRouter>
);

export default App;
